import {
    IExternalDirectoryActionTypes,
    IExternalDirectoryRecord,
    IManageExternalDirectorySearchParams,
} from "./types";

export type IExternalDirectoryActions =
    | {
          type: IExternalDirectoryActionTypes.SET_EXTERNAL_DIRECTORY;
          payload: IExternalDirectoryRecord[];
      }
    | {
          type: IExternalDirectoryActionTypes.EXTERNAL_DIRECTORY_LOADING;
          payload: boolean;
      }
    | {
          type: IExternalDirectoryActionTypes.ADD_EXTERNAL_DIRECTORY_ITEM;
          payload: IExternalDirectoryRecord;
      }
    | {
          type: IExternalDirectoryActionTypes.EDIT_EXTERNAL_DIRECTORY_ITEM;
          payload: IExternalDirectoryRecord;
      }
    | {
          type: IExternalDirectoryActionTypes.EDIT_EXTERNAL_DIRECTORY_ITEM_LOADING;
          payload: boolean;
      }
    | {
          type: IExternalDirectoryActionTypes.DELETE_EXTERNAL_DIRECTORY_ITEM;
          payload: string;
      }
    | {
          type: IExternalDirectoryActionTypes.DELETE_EXTERNAL_DIRECTORY_ITEM_LOADING;
          payload: boolean;
      }
    | {
          type: IExternalDirectoryActionTypes.EXTERNAL_DIRECTORY_ERROR;
          payload: string;
      }
    | {
          type: IExternalDirectoryActionTypes.SET_MANAGE_EXTERNAL_DIRECTORY_SEARCH_PARAMS;
          payload: IManageExternalDirectorySearchParams;
      };

export const setManageExternalDirectorySearchParams = (
    params: Partial<IManageExternalDirectorySearchParams>
): IExternalDirectoryActions => ({
    type:
        IExternalDirectoryActionTypes.SET_MANAGE_EXTERNAL_DIRECTORY_SEARCH_PARAMS,
    payload: params,
});

export const getExternalDirectoryLoading = (
    payload: boolean
): IExternalDirectoryActions => ({
    type: IExternalDirectoryActionTypes.EXTERNAL_DIRECTORY_LOADING,
    payload,
});

export const deleteExternalDirectoryItemLoading = (
    payload: boolean
): IExternalDirectoryActions => ({
    type: IExternalDirectoryActionTypes.DELETE_EXTERNAL_DIRECTORY_ITEM_LOADING,
    payload,
});

export const addExternalDirectoryItem = (
    payload: IExternalDirectoryRecord
): IExternalDirectoryActions => ({
    type: IExternalDirectoryActionTypes.ADD_EXTERNAL_DIRECTORY_ITEM,
    payload,
});

export const editExternalDirectoryItemLoading = (
    payload: boolean
): IExternalDirectoryActions => ({
    type: IExternalDirectoryActionTypes.EDIT_EXTERNAL_DIRECTORY_ITEM_LOADING,
    payload,
});

export const setExternalDirectoryContacts = (
    payload: IExternalDirectoryRecord[]
): IExternalDirectoryActions => ({
    type: IExternalDirectoryActionTypes.SET_EXTERNAL_DIRECTORY,
    payload,
});

export const setExternalDirectoryError = (
    payload: string
): IExternalDirectoryActions => ({
    type: IExternalDirectoryActionTypes.EXTERNAL_DIRECTORY_ERROR,
    payload,
});
